<template>
  <div class="ce-searchResult-documentAsset">
    <div class="ce-documentResults-col ce-col1">
      <div class="ce-documentResult-rowToggle" />
      <div class="ce-documentResult-selectCta">
        <checkbox
          class="ce-checkbox--small"
          :id="`${asset.id}`"
          :value="isInBasket"
          @input="toggleBasket"
          :show-label="false" />
      </div>
      <result-state-indicators
        v-if="isMySheets && isNew"
        :show-new="isNewDocument"
        :show-updated="isNewVersion" />
    </div>
    <div class="ce-documentResults-col ce-col2">
      <div>
        <template v-if="typeLabel">
          {{ typeLabel }}
        </template>
        <template v-else>
          {{ industriesLabel }}
        </template>

        <fa-icon
          v-if="mostRestrictiveAccessLevel && mostRestrictiveAccessLevel.code === 'internal'"
          transform="up-4 shrink-4"
          icon="lock" />
      </div>
      <div
        class="ms-2 ce-colorTextMuted italic"
        v-if="typeLabel && industriesLabel">
        {{ industriesLabel }}
      </div>
    </div>
    <div class="ce-documentResults-col ce-col3">
      {{ created }}
    </div>
    <div class="ce-documentResults-col ce-col4">
      {{ version }}

      <tooltip
        class="ce-changelog"
        v-if="asset.changelog"
        :content="asset.changelog">
        : {{ asset.changelog }}
      </tooltip>
    </div>
    <div class="ce-documentResults-col ce-col5">
      {{ niceFileSize }}
    </div>
    <div class="ce-documentResults-col ce-col6">
      <div class="ce-documentResult-favoriteCta">
        <a
          href=""
          @click.prevent="toggleFavorite">
          <fa-icon :icon="favoriteStateIcon" />
        </a>
      </div>

      <div class="ce-documentResult-downloadCta">
        <a
          href=""
          @click.prevent="downloadAsset"
          target="_blank"
          :disabled="downloadRunning">
          <fa-icon
            v-if="!downloadRunning"
            icon="download" />
          <fa-icon
            v-else
            icon="spinner"
            spin />
        </a>
      </div>

      <copy-to-clipboard
        v-if="showDirectDownloadLinkCta"
        class="ce-productSheet-getLinkCta"
        :content="directDownloadLink">
        <a href="">
          <fa-icon icon="link" />
        </a>
      </copy-to-clipboard>

      <div
        v-if="showHistoryAction"
        class="ce-documentResult-historyCta">
        <a
          href=""
          @click.prevent="showHistory">
          <fa-icon icon="history" />
        </a>
      </div>
    </div>

    <document-version-history-modal
      v-if="showHistoryAction && historyVisible"
      @close="historyVisible = false"
      :asset="asset"
      :product="product" />
  </div>
</template>

<script>
import DocumentResultAsset from 'mixins/product-sheets/DocumentResultAsset';
import CopyToClipboard from 'components/CopyToClipboard.vue';
import ResultStateIndicators from 'components/ResultStateIndicators.vue';
import DocumentVersionHistoryModal from './DocumentVersionHistoryModal.vue';

export default {
  mixins: [DocumentResultAsset],
  components: { DocumentVersionHistoryModal, CopyToClipboard, ResultStateIndicators },
  computed: {
    industriesLabel() {
      if (!this.asset.industries || this.industries.length === this.asset.industries.length) {
        return this.$t('productSheets.industries.forDesktop');
      }

      return this.industries.filter((ind) => this.asset.industries.includes(ind.code)).map((ind) => ind.title).join(', ');
    }
  }
};
</script>

<style lang="less">
  @import (reference) '~styles/includes/base';

  .ce-searchResult-documentAsset {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    transition: all 250ms ease-in-out;
    padding: @space-3 @space-2;
    .ms(-1);
    border-bottom: 1px solid @color-mono-92;

    &:hover {
      background: @color-mono-92;
    }

    .ce-documentResults-col {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;

      &.ce-col1 {
        min-height: 21px;
      }

      &.ce-col2 {
        padding-left: @space-3;
      }
    }
  }
</style>
